// reverbRoom.js — the room a reverb plays: its impulse response
// -----------------------------------------------
// Pure, so it can be tested without an AudioContext: reverb.js puts the
// samples in an AudioBuffer and plays them through a ConvolverNode.

const HIGH_SHARE = 0.25;           // the highs ring this share of `time`

/**
 * A stereo impulse response, [left, right] Float32Arrays: `pre` seconds of
 * nothing, a few early reflections in the first 40 ms, then noise whose
 * part below `damp` Hz dies to -60 dB over `time` and the part above over
 * a quarter of it. `random` is for tests.
 */
export function roomResponse(sr, { time, damp, pre }, random = Math.random) {
  const preN = Math.round(pre * sr);
  const length = preN + Math.max(1, Math.round(time * sr));
  const a = 1 - Math.exp(-2 * Math.PI * damp / sr);        // one-pole split at damp
  const kLow = 6.908 / time;                                // -60 dB at time
  const kHigh = 6.908 / (time * HIGH_SHARE);
  const onsetN = Math.max(1, Math.round(0.004 * sr));       // the tail fades in over 4 ms
  const out = [];
  for (let ch = 0; ch < 2; ch++) {
    const d = new Float32Array(length);
    let lp = 0;
    for (let i = preN; i < length; i++) {
      const t = (i - preN) / sr;
      const x = random() * 2 - 1;
      lp += a * (x - lp);
      const tail = lp * Math.exp(-kLow * t) + (x - lp) * Math.exp(-kHigh * t);
      d[i] = 0.5 * tail * Math.min(1, (i - preN) / onsetN);
    }
    // early reflections: a few walls in the first 40 ms, not the same each side
    for (let r = 0; r < 6; r++) {
      const i = preN + Math.round((0.003 + random() * 0.037) * sr);
      if (i < length) d[i] += (random() < 0.5 ? -1 : 1) * (0.9 - r * 0.12);
    }
    out.push(d);
  }
  return out;
}
